// extracted by mini-css-extract-plugin
module.exports = {"Panel":"Panel_Panel__2GZhS","PanelContentWrapper":"Panel_PanelContentWrapper___wkab","allowOverflow":"Panel_allowOverflow__3KdAI","PanelContent":"Panel_PanelContent__3bZtj"};